import { render, staticRenderFns } from "./CustomerContainer.vue?vue&type=template&id=2179ce86&scoped=true&"
import script from "./CustomerContainer.vue?vue&type=script&lang=js&"
export * from "./CustomerContainer.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContainer.vue?vue&type=style&index=0&id=2179ce86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2179ce86",
  null
  
)

export default component.exports